<template>
  <div>
    <v-app id="mainApp">
      <v-main>
        <v-toast />
        <router-view />
      </v-main>
    </v-app>
    <e-modal />
    <e-modal-dinamic />
    <e-loader />

    <!-- VLibras Widget -->
    <div vw class="enabled">
      <div vw-access-button class="active"></div>
      <div vw-plugin-wrapper>
        <div class="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { VToast } from "vuetify-snackbar-toast";
import { mapActions } from "vuex";

export default {
  name: "App",
  components: { VToast },
  data() {
    return {
      vlibrasWidget: null,
    };
  },
  methods: {
    ...mapActions("Auth", ["verificarForcaDaSenha"]),
    loadVLibras() {
      const script = document.createElement("script");
      script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
      script.async = true;
      script.onload = () => {
        this.vlibrasWidget = new window.VLibras.Widget("https://vlibras.gov.br/app");
      };
      document.head.appendChild(script);
    },
  },
  mounted() {
    document.title = process.env.VUE_APP_PAGE_TITLE;
    this.$loaderService.loadBasicDataIfNeeded();
    // this.$services.authService.verificarForcaDaSenha();
    this.verificarForcaDaSenha();
    this.loadVLibras();
  },
};
</script>
<style scoped>
#mainApp {
  background-color: #efefef;
}
</style>
